export default __webpack_public_path__ + "static/syed-waqas-3cd3a9e7b0d65d6426760a42e442be26.jpeg";